import styled, { css } from 'styled-components';
import { mobile_xl } from '../../../global/mediaQueryMixin';
import { FlexBetween } from '../../../global/commonStyle';

const Icon = styled.div`
  ${FlexBetween}
  cursor: pointer;
  ${mobile_xl(css`
    padding: var(--space-8);
    justify-content: center;
    svg {
      width: 20px;
      height: 20px;
    }
  `)}
`;

export { Icon };
